// Root type
export const AUTHORIZATION_ROOT = 'authorization/';
export const AUTHORIZATION_API_SESSION = 'api/session/';

// Actions types
export const LOGOUT_WS = 'logout';
export const REFRESH_TOKEN_WS = 'refreshToken';

// Getters types
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const REFRESHING_TOKEN = 'refreshingToken';
export const TEMPORARY_ACCESS_TOKEN = 'temporaryAccessToken';

// Mutations types
export const SET_ACCESS_TOKEN = 'setAccessToken';
export const SET_REFRESH_TOKEN = 'setRefreshToken';
export const SET_TOKENS = 'setTokens';
export const SET_TEMPORARY_TOKENS = 'setTemporaryTokens';
export const SET_REFRESHING_TOKEN = 'setRefreshingToken';
export const AUTHORIZATION_RESET_STATE = 'authorizationResetState';
